import { cn } from '@/true-fsd/shared/utils/css'

/**
 * Пропсы для иконки выравнивания по правому краю
 */
export interface AlignmentRightIconProps {
    /**
     * Дополнительные CSS классы
     */
    className?: string
}

/**
 * Иконка выравнивания текста по правому краю
 */
export function AlignmentRightIcon({ className }: AlignmentRightIconProps) {
    return (
        <svg
            width="15"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={cn(className)}
            aria-hidden="true"
            preserveAspectRatio="xMidYMid meet"
        >
            <path
                d="M4 6H19M8.5 10H19M4 14H19M8.5 18H19"
                stroke="#94A6AF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
